import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'
import { UserFile } from 'service/user'

export const useGetImageInfo = (
  imageId: number | null,
  currentDescription: string
) => {
  return useQuery({
    queryKey: ['image-info', imageId],
    queryFn: () => aiStudioService.getUploadImageInfo(imageId!), // API 함수
    enabled: !!imageId && currentDescription === '',
    refetchInterval: (query) => {
      // query.state.data가 실제 응답 데이터
      const data = query.state.data
      if (
        data?.garmentAnalysisStatus === 'completed' ||
        data?.garmentAnalysisStatus === 'failed'
      ) {
        return false // 폴링 중단
      }
      return 3000 // 3초마다 폴링 계속
    },
    refetchIntervalInBackground: false,
    staleTime: 1000,
  })
}
